import { Archive, BadgeCheck, CalendarClock, Check, FilePenLine, KeyRound, PackageCheck, RotateCcw, ShoppingCart, Truck, Wrench, type LucideIcon } from "lucide-react";
import { statusLabels, type VehicleStatus } from "../../shared/domain";

type Tone = "neutral" | "info" | "warning" | "success" | "complete";

// Presentación, no otra máquina de estados: las etiquetas siguen viniendo del dominio.
const appearance = {
  draft: { icon: FilePenLine, tone: "neutral" },
  purchased: { icon: ShoppingCart, tone: "info" },
  in_transit: { icon: Truck, tone: "info" },
  received: { icon: PackageCheck, tone: "info" },
  in_preparation: { icon: Wrench, tone: "warning" },
  available: { icon: Check, tone: "success" },
  reserved: { icon: CalendarClock, tone: "warning" },
  sold: { icon: BadgeCheck, tone: "complete" },
  delivered: { icon: KeyRound, tone: "complete" },
  returned: { icon: RotateCcw, tone: "warning" },
  written_off: { icon: Archive, tone: "neutral" },
} satisfies Record<VehicleStatus, { icon: LucideIcon; tone: Tone }>;

export function StatusBadge({ status }: { status: VehicleStatus }) {
  const { icon: Icon, tone } = appearance[status];
  return <span className={`status-badge status-badge--${status}`} data-tone={tone}>
    <Icon aria-hidden="true" />
    <span className="status-badge__label">{statusLabels[status]}</span>
  </span>;
}
